import React from 'react';
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';

interface TableFooterProps {
  currentPage: number;
  totalPages: number;
  rowsPerPage: number;
  totalResults: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
  isFetching?: boolean;
}

const TableFooter: React.FC<TableFooterProps> = ({
  currentPage,
  totalPages,
  rowsPerPage,
  totalResults,
  hasPreviousPage,
  hasNextPage,
  onPreviousPage,
  onNextPage,
  isFetching
}) => {
  const { t } = useTranslation(['common']);

  // Calculate the range of items being shown
  const startItem = (currentPage - 1) * rowsPerPage + 1;
  const endItem = Math.min(currentPage * rowsPerPage, totalResults);

  return (
    <div className="flex justify-between py-8 gap-2 items-center">
      <div className="text-sm font-normal text-neutral-600">
        {totalResults > 0 && (
          <>
            {t('showing')}{' '}
            <span className="font-semibold">
              {startItem}-{endItem}
            </span>
          </>
        )}
      </div>
      <div className="gap-2 flex items-center text-neutral-500">
        <button
          disabled={!hasPreviousPage || isFetching}
          className="disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={onPreviousPage}
          type="button"
          aria-label="Previous page"
        >
          <BiChevronLeft size={26} />
        </button>
        <div className="font-normal text-sm">
          {`${currentPage} ${t('of')} ${totalPages}`}
        </div>
        <button
          disabled={!hasNextPage || isFetching}
          className="disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={onNextPage}
          type="button"
          aria-label="Next page"
        >
          <BiChevronRight size={26} />
        </button>
      </div>
    </div>
  );
};

export default TableFooter;
